import { GnosisSafeInfo } from '@cowprotocol/wallet'

import { EnhancedTransactionDetails } from 'legacy/state/enhancedTransactions/reducer'
import type { Order } from 'legacy/state/orders/actions'

/**
 * Object derived from the activity state
 */
export interface ActivityDerivedState {
  id: string
  status: ActivityStatus
  type: ActivityType
  summary?: string
  activityLinkUrl?: string

  // Convenient flags
  isTransaction: boolean
  isOrder: boolean
  isPending: boolean
  isConfirmed: boolean
  isExpired: boolean
  isCancelling: boolean
  isCancelled: boolean
  isReplaced: boolean
  isPresignaturePending: boolean
  isUnfillable?: boolean
  // EthFlow flags
  isCreating: boolean
  isFailed: boolean
  // Bridge loading flag
  isLoading?: boolean
  // TODO: refactor these convenience flags

  // Possible activity types
  enhancedTransaction?: EnhancedTransactionDetails
  order?: Order

  // Gnosis Safe
  gnosisSafeInfo?: GnosisSafeInfo

  // Eth-flow order related transactions
  orderCreationTxInfo?: OrderCreationTxInfo
}

export interface OrderCreationTxInfo {
  orderCreationTx: EnhancedTransactionDetails
  orderCreationLinkedTx?: EnhancedTransactionDetails
}

export enum ActivityStatus {
  PENDING,
  PRESIGNATURE_PENDING,
  CONFIRMED,
  EXPIRED,
  CANCELLING,
  CANCELLED,
  CREATING,
  FAILED,
  LOADING,
}

export enum ActivityType {
  ORDER = 'order',
  TX = 'tx',
}
